import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'
import ApiConfig from '../communicate/ApiConfig'

export default class ServiceRequest extends BaseModelRequest {

  getModelName () {
    return "services";
  }

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  loadTotalServices() {
    const url = this.getModelName();
    return this.get(url);
  }

  getGroupService() {
    const url = 'services/groups'
    return this.get(url)
  }

  getDetailService(id) {
    const url = `service/${id}`;
    return this.get(url);
  }

  viewResult(order) {
    const url = 'service/order'
    return this.post(url, order);
  }

  orderService(order) {
    const url = 'order-service'
    return this.post(url, order);
  }

  getLasoNative(id) {
    const url = `laso/native/${id}`
    return this.get(url);
  }

  getLasoAttrs() {
    const  url = 'laso/attribute';
    return this.get(url);
  }

  getNhaO() {
    const  url = 'nha_o/content';
    return this.get(url);
  }

  getTaiLoc() {
    const  url = 'tai_loc/content';
    return this.get(url);
  }

  getCaiVanContent(id) {
    const url = `laso/${id}`
    return this.get(url, '', ApiConfig.v2);
  }

  getFlashSale() {
    const url = `flash_sales`;
    return this.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/request/ServiceRequest.js